import React from "react";
import classnames from "classnames";
import { connect } from 'react-redux'
import { authActions } from 'modules/auth/actions';

import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Progress } from 'reactstrap';

import {
  Button,
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
} from "reactstrap";


import './AdminNavbar.css';

class AdminNavbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapseOpen: false,
      color: "navbar-transparent",
    };
  }

   breadCrumb () {

    return(
      // this.props.breadCrumb, this.props.activeTitle
      <ul class="adm-breadcrumb">
        { this.props.breadCrumb && this.props.breadCrumb.map( (itm,idx) => {
          return ( 
            <li class="adm-breadcrumb-item"><a href={itm.link}>{itm.title}</a></li> 
            ) ;
        })}
        <li class="active adm-breadcrumb-item" aria-current="page">{this.props.activeTitle}</li> 
      </ul>
  
  
    );
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateColor);
  }
  componentDidUpdate(e) {
    if (
      window.outerWidth < 993 &&
      e.history.location.pathname !== e.location.pathname &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
    }
  }
  // function that adds color white/transparent to the navbar on resize (this is for the collapse)
  updateColor = () => {
    if (window.innerWidth < 993 && this.state.collapseOpen) {
      this.setState({
        color: "bg-white",
      });
    } else {
      this.setState({
        color: "navbar-transparent",
      });
    }
  };
  // this function opens and closes the sidebar on small devices
  toggleSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
  };
  // this function opens and closes the collapse on small devices
  // it also adds navbar-transparent class to the navbar when closed
  // ad bg-white when opened
  toggleCollapse = () => {
    let newState = {
      collapseOpen: !this.state.collapseOpen,
    };
    if (!this.state.collapseOpen) {
      newState["color"] = "bg-white";
    } else {
      newState["color"] = "navbar-transparent";
    }
    this.setState(newState);
  };
  render() {
    return (
      <>
        <Navbar
          className={classnames("navbar-absolute fixed-top", this.state.color)}
          expand="lg"
        >
          <Container fluid>
            <div className="navbar-wrapper">
              <div className="navbar-minimize">
                <Button
                  className="btn-icon btn-round"
                  color="default"
                  id="minimizeSidebar"
                  onClick={this.props.handleMiniClick}
                > 
                  <i className="fa fa-bars text-center visible-on-sidebar-mini" />
                  <i className="fa fa-outdent text-center visible-on-sidebar-regular" />
                </Button>
              </div>
              <div
                className={classnames("navbar-toggle", {
                  toggled: this.state.sidebarOpen,
                })}
              >
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={this.toggleSidebar}
                >
                  <span className="navbar-toggler-bar bar1" />
                  <span className="navbar-toggler-bar bar2" />
                  <span className="navbar-toggler-bar bar3" />
                </button>
              </div>
 
              {this.props.breadCrumb.length>0? 
                this.breadCrumb()
              :
                <NavbarBrand href="#inicio" onClick={(e) => e.preventDefault()}>
                  <span className="d-none d-md-block">
                    {this.props.mainTitle?this.props.mainTitle:this.props.school.name} 
                  </span>
                  

                  <span className="d-block d-md-none">Alumni</span>
                </NavbarBrand>
              }              

            </div>

            <button
              aria-controls="navigation-index"
              aria-expanded={this.state.collapseOpen}
              aria-label="Toggle navigation"
              className="navbar-toggler"
              // data-target="#navigation"
              data-toggle="collapse"
              type="button"
              onClick={this.toggleCollapse}
            >
              <span className="navbar-toggler-bar navbar-kebab" />
              <span className="navbar-toggler-bar navbar-kebab" />
              <span className="navbar-toggler-bar navbar-kebab" />
            </button>
            <Collapse
              className="justify-content-end"
              navbar
              isOpen={this.state.collapseOpen}
            >

              {/* Search box */}
{/*               
              <Form>
                <InputGroup className="no-border">
                  <Input defaultValue="" placeholder="Search..." type="text" />
                  <InputGroupAddon addonType="append">
                    <InputGroupText>
                      <i className="nc-icon nc-zoom-split" />
                    </InputGroupText>
                  </InputGroupAddon>
                </InputGroup>
              </Form> */}


              <Nav navbar>
 
                {this.props.contextDropMenu.length>0 &&
 
                    <UncontrolledDropdown 
                          // className="btn-rotate"
                          nav>
                      <DropdownToggle
                        aria-haspopup={true}
                        caret
                        color="default"
                        data-toggle="dropdown"
                        id="navbarDropdownMenuLink"
                        nav
                      >
                        <i className="fa fa-file-text-o" />
                        <p>
                          <span className="d-lg-none d-md-block">Acciones</span>
                        </p>
                      </DropdownToggle>
                      
                      <DropdownMenu
                        persist
                        aria-labelledby="navbarDropdownMenuLink"
                        right
                      >
                        {this.props.contextDropMenu.map( ( item ) => {
                          return (
                              <DropdownItem 
                                href="#inicio"  
                                onClick={ () => item.action(true, item.id)} >

                                {item.label}
                              </DropdownItem>
                          )
                        })}


                      </DropdownMenu>
                    </UncontrolledDropdown>
            }
                {/* Settings Icon */}
{/* 
                <NavItem>
                  <NavLink
                    className="btn-rotate"
                    href="#inicio"
                    onClick={(e) => e.preventDefault()}
                  >
                    <i className="nc-icon nc-settings-gear-65" />
                    <p>
                      <span className="d-lg-none d-md-block">Account</span>
                    </p>
                  </NavLink>
                </NavItem> */}

                {/* Logout Icon */}
                <NavItem>
                  <NavLink
                    className="btn-rotate"
                    href="#inicio"
                    onClick={this.props.logout}
                  >
                    <i className="nc-icon nc-button-power" />
                    <p>
                      <span className="d-lg-none d-md-block">Salir del Sistema</span>
                    </p>
                  </NavLink>
                </NavItem>

              </Nav>
            </Collapse>
          </Container>
           
        </Navbar>
         {/* Loading something indicator */}
        { 
          this.props.isLoading &&  
          <Progress striped animated color="danger" value="100" /> }
      </>
    );
  }
}

const mapStateToProps = state => {

  return {
    session: state.auth.session,
    school: state.config.school,
    isLoading: state.view.isLoading 
  }
}

const mapDispatchToProps = dispatch => {
  return {
      logout: () => {
          dispatch(authActions.logout());
        } 
  
  }
  }


export default connect(mapStateToProps, mapDispatchToProps)(AdminNavbar);

